module.exports = __webpack_public_path__ + "img/sp5.be727290.jpg";